<template>
<div class="container">
  <div class="header">
    <img :src="logo" alt="" @click="toHome()">
    <ul class="ul-li">
      <li
        v-for="(item,index) in title"
        :key="item.id"
        @click="toList(item, index)"
      >{{item.title}}
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import axios from "axios";
import logo from '@/assets/logo.png'
import { mapMutations } from 'vuex'
import { orgId, requestUrl } from '../../common/cons'
export default {
name: "tabs1",
  data(){
  return{
    logo:logo,
  }
  },
  props:{
  title:{
    type:Array
  }
  },
  methods:{
    ...mapMutations([
      'updateMainColumnId',
      'updateArticleId'
    ]),
  toHome(){
    this.$router.push('/')
    this.updateMainColumnId(0)
  }, toList (item, index) {
        if (item.title === '首页') {
          this.updateMainColumnId(0)
          this.$router.push({
            path:'/'
          })
        } else {
          if (item.type === 'channel') {
            this.updateMainColumnId(467)
            this.$router.push(`/news/${467}`)
          } else if(item.type === 'article'){
            // const result = axios.get(`${requestUrl}/news/article?id=${item.colmun_id}&orgId=${orgId}`)
            const result = axios.get(`${requestUrl}/news/article?id=${item.colmun_id}&orgId=${orgId}`)
            // console.log("下面打印的是：result")
            // console.log(result)
            result.then(result=>{
              const articleId = result.data[0].id
              this.$router.push({
                path: `/content/${articleId}`
              })
              this.updateMainColumnId(item.colmun_id)
              this.updateArticleId(articleId)
            })
          }
          else {
            this.$router.push({
              path:'/'
            })
          }

        }
      }

  }
}
</script>

<style scoped>
.cantainer{
  display: flex;
  flex-direction: column;
  align-content: center;
}
.header{
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.header img{
  width: 600px;
  margin-left: 50px;
  cursor: pointer;
}
.ul-li{
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  width: 40%;
  margin-right: 50px;
}
.ul-li li{
  font-weight: 700;
  color: #444;
  cursor: pointer;
}
.ul-li li:hover{
  color: #2574c2;
}

</style>



// WEBPACK FOOTER //
// src/components/tabs/tabs1.vue